// translations.js — переключение языков

const translations = {
  en: {
    // NAV
    'nav-why': 'Why replace',
    'nav-advantage': 'Our Advantage',
    'nav-technologies': 'Technologies',
    'nav-contacts': 'Contacts',
    // HEADER
    'header-call': 'Call me',
    // MOBILE MENU
    'mobile-call': 'Call me',
    // HERO
    'hero-title':
      'Modern, <span>Energy Star certified</span> windows and doors',
    'hero-text':
      "Upgrade your home's energy efficiency backed by a lifetime warranty.",
    'hero-location': 'Our service area',
    // GEO MODAL
    'geo-title': 'The list of cities of presence',
    'geo-text':
      'We work in and around all major cities in Southern Ontario including Toronto, Oakville, Mississauga, Brampton, Aurora, Barrie, Richmond Hill, Thornhill, Whitby, Maple, Newmarket, Guelph, Pickering, Georgina, Orillia, Uxbridge, Hamilton, Welland and the Niagara 🍁',
    // ESTIMATE
    'estimate-step1': 'STEP 1 OF 3',
    'estimate-step2': 'STEP 2 OF 3',
    'estimate-step3': 'STEP 3 OF 3',
    'estimate-title': 'Get a <span class="highlight">FREE</span> estimate',
    'estimate-postal': 'Postal code',
    'estimate-postal-placeholder': 'E.g., H0H 0H0',
    'estimate-quantity': 'How many windows & doors to replace',
    'estimate-next': 'NEXT STEP',
    'estimate-badge': 'No Obligation, Zero Pressure',
    'estimate-q1': 'How old are your current windows and doors?',
    'estimate-age1': 'Less than 5 years',
    'estimate-age2': '5 to 10 years',
    'estimate-age3': 'Over 10 years old',
    'estimate-q2':
      'Are you looking to complete this project in the next 90 days?',
    'estimate-yes': 'Yes',
    'estimate-no': 'No',
    'estimate-step3-title': 'Who are we preparing this estimate for?',
    'estimate-name': 'Full Name',
    'estimate-email': 'Email Address',
    'estimate-phone': 'Phone Number',
    'estimate-send': 'SEND',
    'estimate-thankyou-title': 'Thank you for your request!',
    'estimate-thankyou-desc':
      'One of our team members will contact you shortly to schedule your Free Estimate and a 25% Discount.',
    'estimate-thankyou-text': 'We will be calling you from this number:',
    'estimate-thankyou-note': '...so please make sure you pick up.',
    // ADVANTAGE
    'advantage-title': 'OUR ADVANTAGE',
    'advantage-text':
      'Patented window technology protects your home in any weather and is guaranteed and with a Lifetime Warranty.',
    'badge-text': 'whole home<br>replacement<br>≈ 8 hours',
    'advantage-bottom-text':
      "The new generation of window glass and construction make window replacement an essential update for many households. This clever and affordable upgrade increases home value, plus <span>replacing your windows and doors with New Energy Efficient models make a HUGE improvement to your home's comfort</span> by eliminating drafts, leeks, window cloudiness and mold. Manufactured in here at home in Toronto, Ontario, Optima's Whole-Home Window Replacement installs in under 8 hours*!",
    // BENEFITS
    'benefits-title': 'Benefits of working <span>with us</span>',
    'benefits-sub1': 'Get back up to $250 per window',
    'benefits-text1':
      'We carry ENERGY STAR® 2021 Most Efficient certified Windows and Doors that qualify for the maximum amount redeemable under the Canada Greener Homes Grant',
    'benefits-sub2': 'Financing Available',
    'benefits-text2':
      'We offer a few fast, flexible, and easy ways to pay for your window replacement project. Payment deferral for 3, 6, or 12 months is available. Payments starting at just $39 per month.',
    'benefits-sub3': 'Lifetime warranty',
    'benefits-text3':
      'We are confident in the durability of our windows and doors! Any components that fail for any reason, will be promptly replaced or repaired.',
    // BETTER VIEW
    'better-title': 'NOW, THAT\'S BETTER! <span class="leaf">🍃</span>',
    'better-text':
      'We carefully remove your old windows and doors and take them away to a recycling facility. <span>Then we install your new windows and doors, caulk the exterior and install trim on the interior. Your new windows and doors are backed by a LifeTime Warranty.</span>',
    'better-btn': 'Take a look',
    // CANADA
    'canada-title': 'CANADA GREENER HOMES GRANT',
    'canada-text':
      'Optima Windows and Doors is an approved installer for The Greener Homes Grant. With our new Energy Star 2026 certified windows and doors, you can forget about window drafts, heat loss, and mold.',
    // REASONS
    'reasons-title': 'When and why replace windows and doors?',
    'reasons-text':
      "If you are experiencing one or more of the following problems, it's time to replace or repair your windows to reduce your energy costs",
    'reason-card1': 'Cloudiness, mold',
    'reason-card2': 'High heat cost',
    'reason-card3': 'Warping, rotting frames',
    'reason-card4': 'Peeling paint',
    // CUSTOMER
    'customer-title': 'customer reviews',
    'customer-review1':
      '"We heard about Optima through our neighbor across the park. They had a sign up, we saw the work that was done, and we were really happy with it and that\'s when we called. Meeting Chris, the salesperson, and getting all the information, - we were really satisfied with what he was able to present to us. We love the style of the windows, we love the color and we love how quiet it is inside."',
    'customer-author1': 'Donna and Trevor, Milton',
    'customer-review2':
      '"I received 3 quotes and awarded Optima Windows to replace all windows in our home. They were competitively priced and accommodating to ALL our custom requests."',
    'customer-author2': 'David Nicholson, Oakville',
    'customer-review3':
      '"We have received several quotes and spent a lot of time entertaining different company representatives. We found that Optima has the highest quality windows for the best value. After the products were installed we couldn\'t be any happier."',
    'customer-author3': 'Ruth, Toronto',
    // REVIEWS
    'review-text1':
      'Upon conducting initial "market research" (we checked a few local businesses) in summer 2025, we chose "Optima Windows and Doors" for the best value and care. Chris Z. spent a few hours in our house explaining every little detail about the work to be done, finance options, answered all our questions, and was available on phone.',
    'review-author1': 'Igor Kolomiets',
    'review-date1': '2 months ago',
    'review-text2':
      "We heard about Optima through our neighbor across the park. They had a sign up, we saw the work that was done, and we were really happy with it and that's when we called. Meeting Chris, the salesperson, and getting all the information — we were really satisfied with what he was able to present to us. We love the style of the windows, we love the color.",
    'review-author2': 'Donna and Trevor, Milton',
    'review-date2': '2 months ago',
    'review-text3':
      "We're at 10 years old builders' windows and had all kinds of issues with them. Hired Optima Windows and Doors to replace just two windows and were amazed by the difference between the old ones and the ones that they installed. Great price, great quality, great team!",
    'review-author3': 'Donald J.Tramp',
    'review-date3': '2 weeks ago',
    // TECHNOLOGY
    'technology-title': 'SUPERIOR TECHNOLOGY',
    'technology-text':
      'Replacing windows and doors with new energy-efficient models will save up to 50% on heating and cooling costs, and make your home feel more comfortable',
    'technology-sub1': 'Low-E Glass',
    'technology-card1':
      'Reflects solar rays in the summer and retains infrared rays in the winter, helping to heat your home. Optima Windows & Doors currently uses a 5th generation Low-E product.',
    'technology-sub2': 'Premium Vinyl',
    'technology-card2':
      'We build heavy-duty windows using premium, surgical-grade vinyl with no fillers or re-grind. This guarantees durability without warping, fading, or loss of performance.',
    'technology-sub3': 'Advanced Spacer System',
    'technology-card3':
      'Any use of aluminum in window construction results in heat loss. To avoid this, Optima does not use any type of metal in its spacer systems.',
    // WINDOWS
    'windows-titile': 'Any types of windows',
    'windows-desc':
      'Replacing windows and doors with new energy-efficient models will save up to 50% on heating and cooling costs, and make your home feel',
    // MODAL
    'modal-title': 'Your request has been received!',
    'modal-text':
      'One of our team members will be calling you soon to schedule a <strong>FREE estimate</strong>.',
    'modal-subtext':
      'Our project manager will inspect and measure your windows and doors, discuss your needs, show you samples of our products and provide you with a custom, no-obligation quote.',
    // FOOTER
    'footer-title': 'LEAVE THE APPLICATION,<br><span>WE WILL CALL YOU</span>',
    'footer-desc':
      'Patented window technology protects your home in any weather and is guaranteed.',
    'footer-phone-label': 'Your phone',
    'footer-phone-placeholder': 'Enter the phone number',
    'footer-name-label': 'Your name',
    'footer-name-placeholder': 'Enter your name',
    'footer-callme': 'CALL ME',
    'footer-follow': 'Follow us',
    'footer-followers': '1k followers',
    'footer-copyright':
      '© 2026 Optima windows and doors.<br />All rights reserved.<br />(647) 952-2191',
    'footer-copyright-mobile':
      ' © 2026 Optima windows and doors. All rights reserved. (647) 952-2191',
    'footer-phone-error':
      'The phone number must contain exactly 12 digits, for example XX(XXX)XXXXXXXX',
    'footer-name-error': 'The name must contain 4 to 64 characters',
    'footer-success-text': 'Please expect call',
    'footer-followers': '1k followers',
  },

  ru: {
    'nav-why': 'Зачем менять',
    'nav-advantage': 'Преимущества',
    'nav-technologies': 'Технологии',
    'nav-contacts': 'Контакты',
    'header-call': 'Позвонить',
    'mobile-call': 'Позвонить',
    'hero-title':
      'Современные, <span>сертифицированные Energy Star</span> окна и двери',
    'hero-text':
      'Повысьте энергоэффективность вашего дома с пожизненной гарантией.',
    'hero-location': 'Зона обслуживания',
    'geo-title': 'Список городов присутствия',
    'geo-text':
      'Мы работаем во всех крупных городах Южного Онтарио, включая Торонто, Оквилл, Миссиссогу, Брамптон, Аврору, Барри, Ричмонд-Хилл, Торнхилл, Уитби, Мейпл, Ньюмаркет, Гуэлф, Пикеринг, Джорджину, Ориллию, Аксбридж, Гамильтон, Велланд и Ниагарский регион. 🍁',
    'estimate-step1': 'ШАГ 1 ИЗ 3',
    'estimate-step2': 'ШАГ 2 ИЗ 3',
    'estimate-step3': 'ШАГ 3 ИЗ 3',
    'estimate-title':
      'Получите <span class="highlight">БЕСПЛАТНУЮ</span> оценку',
    'estimate-postal': 'Почтовый индекс',
    'estimate-postal-placeholder': 'Напр., H0H 0H0',
    'estimate-quantity': 'Сколько окон и дверей заменить',
    'estimate-next': 'СЛЕДУЮЩИЙ ШАГ',
    'estimate-badge': 'Без обязательств, без давления',
    'estimate-q1': 'Сколько лет вашим текущим окнам и дверям?',
    'estimate-age1': 'Менее 5 лет',
    'estimate-age2': 'От 5 до 10 лет',
    'estimate-age3': 'Более 10 лет',
    'estimate-q2': 'Планируете завершить проект в течение 90 дней?',
    'estimate-yes': 'Да',
    'estimate-no': 'Нет',
    'estimate-step3-title': 'Для кого мы готовим эту оценку?',
    'estimate-name': 'Полное имя',
    'estimate-email': 'Электронная почта',
    'estimate-phone': 'Номер телефона',
    'estimate-send': 'ОТПРАВИТЬ',
    'estimate-thankyou-title': 'Спасибо за вашу заявку!',
    'estimate-thankyou-desc':
      'Один из наших менеджеров свяжется с вами для записи на бесплатную оценку и скидку 25%.',
    'estimate-thankyou-text': 'Мы позвоним вам с этого номера:',
    'estimate-thankyou-note': '...пожалуйста, возьмите трубку.',
    'advantage-title': 'НАШЕ ПРЕИМУЩЕСТВО',
    'advantage-text':
      'Запатентованная технология окон защищает ваш дом в любую погоду и имеет пожизненную гарантию.',
    'badge-text': 'замена всего дома<br>≈ 8 часов',
    'advantage-bottom-text':
      'Новое поколение оконного стекла и конструкций делает замену окон необходимым обновлением для многих домовладельцев. Умное и доступное обновление повышает стоимость дома, а <span>замена окон и дверей на новые энергоэффективные модели значительно улучшает комфорт вашего дома</span>, устраняя сквозняки, протечки, помутнение и плесень. Производится в Торонто, Онтарио — установка менее чем за 8 часов*!',
    'benefits-title': 'Преимущества работы <span>с нами</span>',
    'benefits-sub1': 'Возврат до $250 за окно',
    'benefits-text1':
      'Мы предлагаем окна и двери с сертификатом ENERGY STAR® 2021, которые дают право на максимальный возврат по программе Canada Greener Homes Grant.',
    'benefits-sub2': 'Доступное финансирование',
    'benefits-text2':
      'Мы предлагаем несколько быстрых и гибких способов оплаты. Отсрочка платежа на 3, 6 или 12 месяцев. Платежи от $39 в месяц.',
    'benefits-sub3': 'Пожизненная гарантия',
    'benefits-text3':
      'Мы уверены в надёжности наших окон и дверей! Любые детали, вышедшие из строя по любой причине, будут оперативно заменены или отремонтированы.',
    'better-title': 'ВОТ ЭТО РАЗНИЦА! <span class="leaf">🍃</span>',
    'better-text':
      'Мы аккуратно снимаем ваши старые окна и двери и отвозим их на переработку. <span>Затем устанавливаем новые окна и двери, герметизируем снаружи и устанавливаем отделку внутри. Новые окна и двери защищены пожизненной гарантией.</span>',
    'better-btn': 'Посмотреть',
    'canada-title': 'ПРОГРАММА CANADA GREENER HOMES GRANT',
    'canada-text':
      'Optima Windows and Doors является одобренным установщиком по программе Greener Homes Grant. С нашими новыми окнами и дверями Energy Star 2026 вы забудете о сквозняках, потерях тепла и плесени.',
    'reasons-title': 'Когда и зачем менять окна и двери?',
    'reasons-text':
      'Если вы столкнулись с одной или несколькими из следующих проблем — пора менять окна, чтобы снизить затраты на энергию.',
    'reason-card1': 'Помутнение, плесень',
    'reason-card2': 'Высокие расходы на отопление',
    'reason-card3': 'Деформация, гниение рам',
    'reason-card4': 'Облупившаяся краска',
    'customer-title': 'Отзывы клиентов',
    'customer-review1':
      '"Мы узнали об Optima от соседа. Увидели их работу и сразу позвонили. Менеджер Крис всё подробно объяснил. Нам очень нравятся стиль окон, цвет и тишина внутри."',
    'customer-author1': 'Донна и Тревор, Милтон',
    'customer-review2':
      '"Я получил 3 предложения и выбрал Optima для замены всех окон в доме. Конкурентная цена и учёт всех пожеланий."',
    'customer-author2': 'Дэвил Николсон, Оклэнд',
    'customer-review3':
      '"Мы рассмотрели много предложений. Optima предлагает лучшее качество за лучшую цену. После установки мы очень довольны."',
    'customer-author3': 'Рут, Торонто',
    'review-text1':
      'Проведя первичный анализ рынка летом 2025 года, мы выбрали Optima Windows and Doors за лучшее соотношение цены и качества. Крис провёл несколько часов, объясняя каждую деталь работы.',
    'review-author1': 'Игорь Коломиец',
    'review-date1': '2 месяца назад',
    'review-text2':
      'Мы узнали об Optima от соседа. Увидели работу и позвонили. Менеджер Крис подробно всё объяснил. Нам нравятся стиль окон и их цвет.',
    'review-author2': 'Донна и Тревор, Милтон',
    'review-date2': '2 месяца назад',
    'review-text3':
      'Нашим окнам было 10 лет и было много проблем. Заменили два окна через Optima и были поражены разницей. Решили заменить остальные. Отличная цена, качество и команда!',
    'review-author3': 'Дональд Трамп младший',
    'review-date3': '2 недели назад',
    'technology-title': 'ПРЕВОСХОДНЫЕ ТЕХНОЛОГИИ',
    'technology-text':
      'Замена окон и дверей на новые энергоэффективные модели сэкономит до 50% на отоплении и охлаждении и сделает ваш дом комфортнее.',
    'technology-sub1': 'Стекло Low-E',
    'technology-card1':
      'Отражает солнечные лучи летом и удерживает инфракрасные лучи зимой, помогая отапливать дом. Optima использует Low-E продукт 5-го поколения.',
    'technology-sub2': 'Премиальный винил',
    'technology-card2':
      'Мы производим прочные окна из премиального медицинского винила без наполнителей и вторичного сырья. Гарантия от деформации, выцветания и потери характеристик.',
    'technology-sub3': 'Усовершенствованная система дистанционирования',
    'technology-card3':
      'Любое использование алюминия в конструкции окна приводит к потере тепла. Поэтому Optima не использует металл в системах дистанционирования.',
    'windows-titile': 'Любые типы окон',
    'windows-desc':
      'Замена окон и дверей на новые энергоэффективные модели сэкономит до 50% на отоплении и охлаждении и сделает ваш дом',
    'modal-title': 'Ваша заявка получена!',
    'modal-text':
      'Один из наших менеджеров свяжется с вами для записи на <strong>БЕСПЛАТНУЮ оценку</strong>.',
    'modal-subtext':
      'Наш менеджер проекта осмотрит ваши окна и двери, обсудит потребности, покажет образцы продукции и предоставит индивидуальное предложение.',
    'footer-title': 'ОСТАВЬТЕ ЗАЯВКУ,<span>МЫ ВАМ ПЕРЕЗВОНИМ</span>',
    'footer-desc':
      'Запатентованная технология окон защищает ваш дом в любую погоду и гарантирована.',
    'footer-phone-label': 'Ваш телефон',
    'footer-phone-placeholder': 'Введите номер телефона',
    'footer-name-label': 'Ваше имя',
    'footer-name-placeholder': 'Введите ваше имя',
    'footer-callme': 'ПОЗВОНИ',
    'footer-follow': 'Подпишись',
    'footer-followers': '1k Подписчиков',
    'footer-copyright':
      '© 2026 Optima windows and doors.<br />Все права защищены.<br />(647) 952-2191',
    'footer-copyright-mobile':
      ' © 2026 Optima windows and doors. Все права защищены. (647) 952-2191',
    'footer-phone-error':
      'Номер должен содержать ровно 12 цифр, например XX(XXX)XXXXXXXX',
    'footer-name-error': 'Имя должно содержать от 4 до 64 символов',
    'footer-success-text': 'Ожидайте звонка',
  },

  ua: {
    'nav-why': 'Навіщо міняти',
    'nav-advantage': 'Переваги',
    'nav-technologies': 'Технології',
    'nav-contacts': 'Контакти',
    'header-call': 'Дзвони',
    'mobile-call': 'Дзвони',
    'hero-title':
      'Сучасні, <span>сертифіковані Energy Star</span> вікна та двері',
    'hero-text':
      'Підвищте енергоефективність вашого будинку з довічною гарантією.',
    'hero-location': 'Зона обслуговування',
    'geo-title': 'Список міст присутності',
    'geo-text':
      'Ми працюємо у всіх великих містах південного Онтаріо, включаючи Торонто, Оуквілл, Міссіссогу, Брамптон, Аврору, Баррі, Річмонд-Гілл, Торнгілл, Вітбі, Мейпл, Ньюмаркет, Гелф, Пікерінг, Джорджину, Оріллію, Аксбрідж, Гамільтон, Велланд та Ніагару. 🍁',
    'estimate-step1': 'КРОК 1 З 3',
    'estimate-step2': 'КРОК 2 З 3',
    'estimate-step3': 'КРОК 3 З 3',
    'estimate-title':
      'Отримайте <span class="highlight">БЕЗКОШТОВНУ</span> оцінку',
    'estimate-postal': 'Поштовий індекс',
    'estimate-postal-placeholder': 'Напр., H0H 0H0',
    'estimate-quantity': 'Скільки вікон і дверей замінити',
    'estimate-next': 'НАСТУПНИЙ КРОК',
    'estimate-badge': "Без зобов'язань, без тиску",
    'estimate-q1': 'Скільки років вашим поточним вікнам і дверям?',
    'estimate-age1': 'Менше 5 років',
    'estimate-age2': 'Від 5 до 10 років',
    'estimate-age3': 'Більше 10 років',
    'estimate-q2': 'Плануєте завершити проект протягом 90 днів?',
    'estimate-yes': 'Так',
    'estimate-no': 'Ні',
    'estimate-step3-title': 'Для кого ми готуємо цю оцінку?',
    'estimate-name': "Повне ім'я",
    'estimate-email': 'Електронна пошта',
    'estimate-phone': 'Номер телефону',
    'estimate-send': 'НАДІСЛАТИ',
    'estimate-thankyou-title': 'Дякуємо за вашу заявку!',
    'estimate-thankyou-desc':
      "Один з наших менеджерів зв'яжеться з вами для запису на безкоштовну оцінку та знижку 25%.",
    'estimate-thankyou-text': 'Ми зателефонуємо вам з цього номера:',
    'estimate-thankyou-note': '...будь ласка, візьміть трубку.',
    'advantage-title': 'НАША ПЕРЕВАГА',
    'advantage-text':
      'Запатентована технологія вікон захищає ваш будинок за будь-якої погоди та має довічну гарантію.',
    'badge-text': 'заміна всього будинку<br>≈ 8 годин',
    'advantage-bottom-text':
      'Нове покоління віконного скла і конструкцій робить заміну вікон необхідним оновленням для багатьох домогосподарств. Розумне і доступне оновлення підвищує вартість будинку, а <span>заміна вікон і дверей на нові енергоефективні моделі значно покращує комфорт вашого дому</span>, усуваючи протяги, витоки, помутніння та цвіль. Виробляється в Торонто, Онтаріо — встановлення менш ніж за 8 годин*!',
    'benefits-title': 'Переваги роботи <span>з нами</span>',
    'benefits-sub1': 'Повернення до $250 за вікно',
    'benefits-text1':
      'Ми пропонуємо вікна та двері з сертифікатом ENERGY STAR® 2021, що дають право на максимальне відшкодування за програмою Canada Greener Homes Grant.',
    'benefits-sub2': 'Доступне фінансування',
    'benefits-text2':
      'Ми пропонуємо кілька швидких і гнучких способів оплати. Відстрочка платежу на 3, 6 або 12 місяців. Платежі від $39 на місяць.',
    'benefits-sub3': 'Довічна гарантія',
    'benefits-text3':
      'Ми впевнені в надійності наших вікон і дверей! Будь-які деталі, що вийшли з ладу з будь-якої причини, будуть оперативно замінені або відремонтовані.',
    'better-title': 'ОСЬ ЦЕ РІЗНИЦЯ! <span class="leaf">🍃</span>',
    'better-text':
      'Ми акуратно знімаємо ваші старі вікна і двері та відвозимо їх на переробку. <span>Потім встановлюємо нові вікна і двері, герметизуємо зовні та встановлюємо оздоблення всередині. Нові вікна і двері захищені довічною гарантією.</span>',
    'better-btn': 'Подивитися',
    'canada-title': 'ПРОГРАМА CANADA GREENER HOMES GRANT',
    'canada-text':
      'Optima Windows and Doors є затвердженим установником за програмою Greener Homes Grant. З нашими новими вікнами та дверима Energy Star 2026 ви забудете про протяги, втрати тепла та цвіль.',
    'reasons-title': 'Коли і навіщо міняти вікна та двері?',
    'reasons-text':
      'Якщо ви зіткнулися з однією або кількома з наступних проблем — час міняти вікна, щоб знизити витрати на енергію.',
    'reason-card1': 'Помутніння, цвіль',
    'reason-card2': 'Високі витрати на опалення',
    'reason-card3': 'Деформація, гниття рам',
    'reason-card4': 'Облупилася фарба',
    'customer-title': 'Відгуки клієнтів',
    'customer-review1':
      '"Ми дізналися про Optima від сусіда. Побачили роботу і одразу зателефонували. Менеджер Кріс все детально пояснив. Нам дуже подобається стиль вікон, колір і тиша всередині."',
    'customer-author1': 'Донна та Тревор, Мілтон',
    'customer-review2':
      '"Я отримав 3 пропозиції і вибрав Optima для заміни всіх вікон у будинку. Конкурентна ціна і врахування всіх побажань."',
    'customer-author2': 'Девід Ніколсон, Окленд',
    'customer-review3':
      '"Ми розглянули багато пропозицій. Optima пропонує найкращу якість за найкращою ціною. Після встановлення ми дуже задоволені."',
    'customer-author3': 'Рут, Торонто',
    'review-text1':
      'Провівши первинний аналіз ринку влітку 2025 року, ми обрали Optima Windows and Doors за найкраще співвідношення ціни та якості. Кріс провів кілька годин, пояснюючи кожну деталь роботи.',
    'review-author1': 'Ігор Коломієць',
    'review-date1': '2 місяця тому',
    'review-text2':
      'Ми дізналися про Optima від сусіда. Побачили роботу і зателефонували. Менеджер Кріс детально все пояснив. Нам подобається стиль вікон і їхній колір.',
    'review-author2': 'Донна та Тревор, Мілтон',
    'review-date2': '2 місяця тому',
    'review-text3':
      'Нашим вікнам було 10 років і було багато проблем. Замінили два вікна через Optima і були вражені різницею. Вирішили замінити решту. Відмінна ціна, якість і команда!',
    'review-author3': 'Дональд Трамп молодший',
    'review-date3': '2 тижня тому',
    'technology-title': 'ЧУДОВІ ТЕХНОЛОГІЇ',
    'technology-text':
      'Заміна вікон і дверей на нові енергоефективні моделі заощадить до 50% на опаленні та охолодженні і зробить ваш будинок комфортнішим.',
    'technology-sub1': 'Скло Low-E',
    'technology-card1':
      'Відбиває сонячні промені влітку і утримує інфрачервоні промені взимку, допомагаючи опалювати будинок. Optima використовує Low-E продукт 5-го покоління.',
    'technology-sub2': 'Преміальний вініл',
    'technology-card2':
      'Ми виробляємо міцні вікна з преміального медичного вінілу без наповнювачів і вторинної сировини. Гарантія від деформації, вицвітання і втрати характеристик.',
    'technology-sub3': 'Вдосконалена система дистанціонування',
    'technology-card3':
      'Будь-яке використання алюмінію в конструкції вікна призводить до втрати тепла. Тому Optima не використовує метал у системах дистанціонування.',
    'windows-titile': 'Будь-які типи вікон',
    'windows-desc':
      'Заміна вікон і дверей на нові енергоефективні моделі заощадить до 50% на опаленні та охолодженні і зробить ваш будинок',
    'modal-title': 'Вашу заявку отримано!',
    'modal-text':
      "Один з наших менеджерів зв'яжеться з вами для запису на <strong>БЕЗКОШТОВНУ оцінку</strong>.",
    'modal-subtext':
      'Наш менеджер проекту огляне ваші вікна і двері, обговорить потреби, покаже зразки продукції та надасть індивідуальну пропозицію.',
    'footer-title': 'ВІДПРАВТЕ ЗАЯВКУ,<span>МИ ВАМ ПЕРЕДЗВОНИМО</span>',
    'footer-desc':
      'Запатентована технологія вікон захищає ваш будинок за будь-якої погоди та гарантована.',
    'footer-phone-label': 'Ваш телефон',
    'footer-phone-placeholder': 'Введіть номер телефону',
    'footer-name-label': "Ваше ім'я",
    'footer-name-placeholder': "Введіть ваше ім'я",
    'footer-callme': 'ДЗВОНИ',
    'footer-follow': 'Підпишись',
    'footer-followers': '1k ПІдписників',
    'footer-copyright':
      '© 2026 Optima windows and doors.<br />Всі права захищені.<br />(647) 952-2191',
    'footer-copyright-mobile':
      ' © 2026 Optima windows and doors. Всі права захищені. (647) 952-2191',
    'footer-phone-error':
      'Номер має містити рівно 12 цифр, наприклад XX(XXX)XXXXXXXX',
    'footer-name-error': "Ім'я має містити від 4 до 64 символів",
    'footer-success-text': 'Очікуйте дзвінка',
  },
};

// =========================
// APPLY LANGUAGE
// =========================

let currentLang = localStorage.getItem('lang') || 'en';

function applyLang(lang) {
  currentLang = lang;
  localStorage.setItem('lang', lang);
  document.documentElement.setAttribute('data-lang', lang);

  const t = translations[lang];

  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (t[key] !== undefined) {
      el.innerHTML = t[key];
    }
  });

  document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
    const key = el.getAttribute('data-i18n-placeholder');
    if (t[key] !== undefined) {
      el.placeholder = t[key];
    }
  });

  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.lang === lang);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.addEventListener('click', () => applyLang(btn.dataset.lang));
  });

  applyLang(currentLang);
});
